import _isNumber from 'lodash/isNumber';
import _isEmpty from 'lodash/isEmpty';
export function formatMileage(num) {
  return "".concat((num / 1000).toFixed(2).replace(/\.[0]{1,2}$/, ''), "K");
}
export function addCommasToNum(num) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
  var localeOptions = arguments.length > 2 ? arguments[2] : undefined;
  // TODO: get locale from i18n or dealerConfig
  return parseFloat("".concat(num), 10).toLocaleString(locale, localeOptions);
}
export function getPercentString(num) {
  return "".concat(num, "%");
}
export function formatDecimalByNumber(value) {
  var number = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var defaultValue = 0;
  var parsedValue = Number(value);
  if (!isNaN(parsedValue)) return Number(parsedValue.toFixed(number));
  return Number(defaultValue.toFixed(number));
}
export function formatDecimalWithoutRounding() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var number = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var stringValue = "".concat(Number(value));
  var decimalIndex = stringValue.indexOf('.');
  if (decimalIndex === -1) return stringValue;
  return stringValue.slice(0, decimalIndex + 1 + number);
}
export function compareNumbers(number1, number2) {
  var decimalLevel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;

  if (_isNumber(number1) && _isNumber(number2)) {
    var decimalNumber1 = formatDecimalByNumber(number1, decimalLevel);
    var decimalNumber2 = formatDecimalByNumber(number2, decimalLevel);
    return decimalNumber1 === decimalNumber2;
  }

  return false;
}
export var formatPhone = function formatPhone(contactNumber) {
  var numberToFormat = !_isEmpty(contactNumber) ? contactNumber.replace(/[^\d]/g, '') : ''; // check if number length equals to 10

  if (numberToFormat.length === 10) {
    // reformat and return phone number
    return numberToFormat.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  }

  return numberToFormat;
};
export var formatSocialSecurityNumber = function formatSocialSecurityNumber(socialSecurityNumber) {
  var numberToFormat = _isEmpty(socialSecurityNumber) ? '' : socialSecurityNumber.replace(/[^\d]/g, '');

  if (numberToFormat.length === 9) {
    return numberToFormat.replace(/(\d{3})(\d{2})(\d{4})/, '$1-$2-$3');
  }

  return numberToFormat;
};